import React, { useEffect, useState } from 'react'
import { addCurriculumProps } from './addcurriculum-interface'
import { Alert, Button, Form, Input, Modal, Progress, Select } from 'antd'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../store/store'
// eslint-disable-next-line
import { getDifference, openNotificationWithIcon } from '../../../../../utils/helper'
import Levelgroup from './levelgroup/levelgroup'
import { createCurriculum } from '../../../../../api/curriculum/curriculum'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

const { Option } = Select


const Addcurriculum = ({ open, closeModal, loadingLanguages, languages, levels, loadingLevels }: addCurriculumProps) => {
	const [form] = Form.useForm();

	const [stageOneData, setStageOneData] = useState({
		name: "",
		description: "",
		languageId: "",
		duration: ""
	})
	const [levelPools, setLevelPools] = useState([])
	const [selectedLessons, setSelectedLessons] = useState([])
	const [selectedRamRuns, setSelectedRamRuns] = useState([])
	const [selectedLevel, setSelectedLevel] = useState('')
	const [selectedLevelDuration, setSelectedLevelDuration] = useState(1)
	const [languageLevels, setLanguageLevels] = useState<any[]>([])
	const [showAddLevel, setShowAddLevel] = useState(false)
	const [currentStage, setCurrentStage] = useState(1)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState<any>(null)
	const [errors, setErrors] = useState({
		name: "",
		description: "",
		languageId: "",
		duration: ""
	})


	const state = useSelector((state: RootState) => ({
		user: state.user.user,
	}))

	// eslint-disable-next-line
	const { user } = state

	const submitStageOne = (values: any) => {
		setError(null)
		setStageOneData((prevState) => ({
			...prevState,
			...values
		}))
		setCurrentStage(2)
	}

	const onFinish = async () => {
		try {
			setLoading(true)
			setError(null)
			setErrors(prevState => ({
				...prevState,
				name: "",
				description: "",
				languageId: "",
				duration: ""
			}))

			const newModules: any[] = []

			levelPools.forEach((item: any, index: number) => {
				let obj: any = {
					name: item.name,
					order: index + 1,
					duration: item.duration,
					units: []
				}

				item.children.forEach((itemInside: any, itemInsideIndex: number) => {
					obj.units.push({
						order: itemInsideIndex + 1,
						typeModel: itemInside.typeModel,
						typeId: itemInside.typeId
					})
				})

				newModules.push(obj)
			})

			const data = {
				...stageOneData,
				duration: Number(stageOneData.duration),
				durationUnit: "week",
				modules: newModules,
			}

			const res = await createCurriculum({ ...data })

			const { message } = res.data

			openNotificationWithIcon("success", "Add Curriculum", message || 'Curriculum added successfully')

			setLoading(false)
			closeModal(true)

		} catch (error: any) {
			setLoading(false)
			const otherErrors: any[] = []
			if (error?.response) {
				if (error?.response?.data?.errors) {
					const resError = error?.response?.data?.errors

					Object.entries(resError).forEach(([key, value]) => {
						if (Object.keys(errors).includes(key)) {
							setErrors(prevState => ({
								...prevState,
								[key]: value
							}))
						} else {
							otherErrors.push(value)
						}
					})

					if (otherErrors.length > 0) {
						const errorList = otherErrors.map((element: any, index) => {
							return <li key={`error-list-${index}`}>{element}</li>
						});
						setError(errorList)
					}

				} else {
					setError(error?.response?.data?.message || 'Something went wrong')
				}
			} else {
				setError('Something went wrong')
			}
		}
	}

	useEffect(() => {
		if (stageOneData.languageId !== "") {
			const filteredLevels = levels.filter((item) => item.languageId === stageOneData.languageId)
			const difference = getDifference(filteredLevels, levelPools, '_id')
			setLanguageLevels(difference)
		}
	}, [levels, stageOneData.languageId, levelPools])

	const getLessonFromSelectedLevel = (levelId: string) => {
		const parentLevel = languageLevels.filter((item) => item._id === levelId)
		const lessons: any[] = []
		parentLevel.forEach((item) => {
			item.children.forEach((itemInside: any) => {
				itemInside.lessons.forEach((itemLesson: any) => {
					lessons.push({
						...itemLesson
					})
				})
			})
		});
		return lessons
	}

	const getRamRunFromSelectedLevel = (levelId: string) => {
		const parentLevel = languageLevels.filter((item) => item._id === levelId)
		const ramRuns: any[] = []
		parentLevel.forEach((item) => {
			item.children.forEach((itemInside: any) => {
				itemInside.ramRuns.forEach((itemRamRun: any) => {
					ramRuns.push({
						...itemRamRun
					})
				})
			})
		});
		return ramRuns
	}

	const getLevelDetails = (levelId: string) => {
		const levelDetails = languageLevels.filter((item) => item._id === levelId)
		return levelDetails[0]
	}

	const getLevelRamRunDetails = (levelId: string, ramRunId: string) => {
		const ramRunPool = getRamRunFromSelectedLevel(levelId)
		const ramRunDetails = ramRunPool.filter((item) => item._id === ramRunId)
		return ramRunDetails[0]
	}

	const getLevelLessonDetails = (levelId: string, lessonId: string) => {
		const lessonPool = getLessonFromSelectedLevel(levelId)
		const lessonDetails = lessonPool.filter((item) => item._id === lessonId)
		return lessonDetails[0]
	}


	const addLevel = () => {
		setError(null)

		if (selectedLevelDuration <= 0) {
			setError('Level Duration must be a week and above')
		} else if (selectedLessons.length === 0 && selectedRamRuns.length === 0) {
			setError('You must select at least one Lesson or one RamRun')
		} else {
			const levelToAdd: any = {
				duration: selectedLevelDuration,
				open: false,
				_id: selectedLevel,
				name: getLevelDetails(selectedLevel).name,
				children: []
			}
			selectedLessons.forEach((item) => {
				levelToAdd.children.push({
					typeId: item,
					typeModel: 'Lesson',
					_id: item,
					title: getLevelLessonDetails(selectedLevel, item).title,
				})
			})
			selectedRamRuns.forEach((item) => {
				levelToAdd.children.push({
					typeId: item,
					typeModel: 'RamRun',
					_id: item,
					title: getLevelRamRunDetails(selectedLevel, item).title,
				})
			})

			const updatedLevels: any = [...levelPools]
			updatedLevels.push(levelToAdd)

			setLevelPools(updatedLevels)
			setShowAddLevel(false)
			setSelectedLevelDuration(1)
		}




		// if (selectedLessons.length > 0 && selectedRamRuns.length > 0) {

		// } else {
		// 	setError('You must select at least one Lesson and one RamRun')
		// }
	}

	const openLevel = (levelIndex: number, value: boolean) => {
		let updatedLevels: any = [...levelPools]
		let newLevels = updatedLevels.map((item: any, index: number) => {
			if (index === levelIndex) {
				return {
					...item,
					open: value
				}
			}

			return {
				...item,
				open: false
			}
		})
		setLevelPools(newLevels)
	}

	const handleDragDrop = (result: any) => {
		const { source, destination, type } = result
		if (!destination) return
		if (source.draggableId === destination.draggableId && source.index === destination.index) return

		const sourceIndex = source.index
		const destinationIndex = destination.index

		if (type === 'group') {
			const reorderedLevelPool = [...levelPools]

			const [removedLevel] = reorderedLevelPool.splice(sourceIndex, 1)
			reorderedLevelPool.splice(destinationIndex, 0, removedLevel)

			return setLevelPools(reorderedLevelPool)
		}

		const newReorderedLevelPool: any = [...levelPools]
		const getWorkingLevelIndex = newReorderedLevelPool.findIndex((item: any) => item._id === source.droppableId)
		const [removedModule] = newReorderedLevelPool[getWorkingLevelIndex].children.splice(sourceIndex, 1)
		newReorderedLevelPool[getWorkingLevelIndex].children.splice(destinationIndex, 0, removedModule)
		setLevelPools(newReorderedLevelPool)
	}

	const removeLevel = (levelIndex: number) => {
		const newLevelPool = [...levelPools]
		newLevelPool.splice(levelIndex, 1)
		setLevelPools(newLevelPool)
	}

	return (
		<div>
			<Modal
				closable={false}
				open={open}
				onOk={() => {
					if (!loading) {
						closeModal()
					}
				}}
				onCancel={() => {
					if (!loading) {
						closeModal()
					}
				}}
				footer={null}
				width={'38rem'}
				className='white-bg-modal'
			>
				<div>
					<div className='flex border-b border-appcolorgreyfour pb-[0.75rem] justify-between items-center'>
						<h1 className='text-[22px] leading-[110%] font-semibold text-appcolorgrey mb-[-1rem]'>Add Curriculum</h1>
						<div className='rounded-full bg-appcolorgreyfive custom-box-shadow-five p-[0.9rem] w-fit cursor-pointer'
							onClick={() => {
								if (!loading) {
									closeModal()
								}
							}}
						>
							<img src="/img/vectors/modalclose.svg" alt="" />
						</div>
					</div>

					<div className='pt-2'>
						<Progress
							percent={50 * currentStage}
							status="normal"
							showInfo={false}
						/>

						<p className='text-sm text-appcolorgrey'>Step {currentStage} of 2</p>

						<div className='flex items-center justify-between'>
							<p className='text-lg font-bold'>
								{
									currentStage === 1 ?
										'General Info' : 'Curriculum Levels'
								}
							</p>

							{
								currentStage === 2 ?
									<div>
										<Button
											className='custom-primary-two-btn smaller-padding'
											onClick={() => {
												setShowAddLevel(true)
											}}
										>
											+ Add Level
										</Button>
									</div>
									: null
							}
						</div>
					</div>

					<div className='mt-[2rem]'>
						{
							error !== null ?
								<div className='mb-4'>
									<Alert message={error} type="error" />
								</div>
								: null
						}

						{
							currentStage === 1 ?
								<Form
									layout="vertical"
									onFinish={submitStageOne}
									form={form}
									initialValues={{
										...stageOneData
									}}
								>
									<Form.Item
										label="Name"
										name="name"
										rules={[{ required: true, message: 'Input is required' }]}
										validateStatus={errors?.name.length > 0 ? 'error' : undefined}
										help={errors?.name.length > 0 ? errors?.name : undefined}
									>
										<Input
											onChange={() => {
												setErrors(prevState => ({
													...prevState,
													name: '',
												}))
											}}
											placeholder="Enter a name for your curriculum"
										/>
									</Form.Item>

									<Form.Item
										label="Duration (Weeks)"
										name="duration"
										rules={[{ required: true, message: 'Input is required' }]}
										validateStatus={errors?.duration.length > 0 ? 'error' : undefined}
										help={errors?.duration.length > 0 ? errors?.duration : undefined}
									>
										<Input
											type="number"
											onChange={() => {
												setErrors(prevState => ({
													...prevState,
													duration: '',
												}))
											}}
											placeholder="Enter the number of duration"
										/>
									</Form.Item>

									<div id="select-language-area">
										<Form.Item
											label="Language"
											name="languageId"
											rules={[{ required: true, message: 'Input is required' }]}
											validateStatus={errors?.languageId.length > 0 ? 'error' : undefined}
											help={errors?.languageId.length > 0 ? errors?.languageId : undefined}
										>
											<Select
												placeholder="What language would you be teaching? "
												loading={loadingLanguages}
												//@ts-ignore
												getPopupContainer={() => document.getElementById('select-language-area')}
												className='capitalize'
											>
												{
													languages.map((item) => (
														<Option key={item?._id} value={item?._id} className="capitalize"
														>
															{item.name}
														</Option>
													))
												}
											</Select>
										</Form.Item>
									</div>

									<Form.Item
										label="Description"
										name="description"
										rules={[{ required: true, message: 'Input is required' }]}
										validateStatus={errors?.description.length > 0 ? 'error' : undefined}
										help={errors?.description.length > 0 ? errors?.description : undefined}
									>
										<Input
											onChange={() => {
												setErrors(prevState => ({
													...prevState,
													description: '',
												}))
											}}
											placeholder="Enter a name for your curriculum"
										/>
									</Form.Item>

									<div className='mt-[2.5rem] flex justify-end'>
										<Button
											onClick={() => {
												if (!loading) {
													closeModal()
												}
											}}
											style={{
												color: '#200E32 !important'
											}}
											disabled={loading}
											className='mr-[0.9rem] custom-white-btn black-text smaller-padding'>

											Cancel
										</Button>

										<Button
											disabled={loading}
											className='custom-primary-two-btn smaller-padding'
											loading={loading}
											htmlType='submit'
										>
											Continue
										</Button>
									</div>
								</Form>
								:
								null
						}

						{
							currentStage === 2 ?
								<>
									{
										showAddLevel ?
											<Form
												layout="vertical"
												onFinish={addLevel}
											>
												<div id="select-level-area">
													<Form.Item
														label="Select Level"
														rules={[{ required: true }]}
													>
														<Select
															placeholder="Select Level"
															className='w-full capitalize'
															//@ts-ignore
															getPopupContainer={() => document.getElementById('select-level-area')}
															onChange={(value) => {
																setSelectedLevel(value)
															}}
														>
															{
																languageLevels.map((item) => (
																	<Option key={item._id} value={item?._id}>
																		{item.name}
																	</Option>
																))
															}
														</Select>
													</Form.Item>
												</div>


												{
													selectedLevel !== '' ?
														<>
															<Form.Item
																label="Duration (Weeks)"
																rules={[{ required: true }]}
															>
																<Input
																	type="number"
																	value={selectedLevelDuration}
																	onChange={(e) => {
																		setSelectedLevelDuration(Number(e.target.value))
																	}}
																	placeholder="Enter the number of duration"
																/>
															</Form.Item>


															<div id="select-lessons-area">
																<Form.Item
																	label="Select Lessons"
																	rules={[{ required: true }]}
																>

																	<Select
																		mode="multiple"
																		placeholder="Select multiple lessons"
																		className='w-full capitalize'
																		//@ts-ignore
																		getPopupContainer={() => document.getElementById('select-lessons-area')}
																		onChange={(value) => {
																			setSelectedLessons(value)
																		}}
																	>
																		{
																			getLessonFromSelectedLevel(selectedLevel).map((item) => (
																				<Option key={item._id} value={item?._id}>
																					{item.title}
																				</Option>
																			))
																		}
																	</Select>
																</Form.Item>
															</div>

															<div id="select-ramruns-area">
																<Form.Item
																	label="Select RamRuns"
																	rules={[{ required: true }]}
																>

																	<Select
																		mode="multiple"
																		placeholder="Select multiple RamRuns"
																		className='w-full capitalize'
																		//@ts-ignore
																		getPopupContainer={() => document.getElementById('select-ramruns-area')}
																		onChange={(value) => {
																			setSelectedRamRuns(value)
																		}}
																	>
																		{
																			getRamRunFromSelectedLevel(selectedLevel).map((item) => (
																				<Option key={item._id} value={item?._id}>
																					{item.title}
																				</Option>
																			))
																		}
																	</Select>

																</Form.Item>
															</div>
														</>
														:
														null
												}

												<div className='mt-[2.5rem] flex justify-end'>
													<Button
														onClick={() => {
															if (!loading) {
																setShowAddLevel(false)
															}
														}}
														style={{
															color: '#200E32 !important'
														}}
														disabled={loading}
														className='mr-[0.9rem] custom-white-btn black-text smaller-padding'>
														Cancel
													</Button>

													<Button
														disabled={loading}
														className='custom-primary-two-btn smaller-padding'
														loading={loading}
														htmlType='submit'
													>
														Add
													</Button>
												</div>
											</Form>
											:
											<div>
												<DragDropContext
													onDragEnd={handleDragDrop}
												>
													<div className='max-h-[19rem] min-h-[19rem] overflow-auto px-4'>
														<Droppable droppableId='levelpools' type="group">
															{(provided) => (
																<div {...provided.droppableProps} ref={provided.innerRef}>
																	{
																		levelPools.map((item: any, index) => (
																			<Draggable
																				draggableId={item._id}
																				key={item?._id}
																				index={index}
																			>
																				{(provided) => (
																					<div {...provided.dragHandleProps} {...provided.draggableProps} ref={provided.innerRef}>
																						<Levelgroup
																							key={item?._id}
																							details={item}
																							index={index}
																							openLevel={openLevel}
																							removeLevel={removeLevel}
																						/>
																					</div>
																				)}
																			</Draggable>

																		))
																	}
																</div>
															)}
														</Droppable>

													</div>
												</DragDropContext>


												{
													levelPools.length > 0 ?
														<>
															<div className='mt-[2.5rem] flex justify-end'>
																<Button
																	disabled={loading}
																	className='custom-primary-two-btn smaller-padding'
																	loading={loading}
																	onClick={() => {
																		onFinish()
																	}}
																>
																	Submit
																</Button>
															</div>
														</>
														:
														<div className='mt-[2.5rem] flex justify-end'>
															<Button
																onClick={() => {
																	if (!loading) {
																		setShowAddLevel(false)
																	}
																}}
																style={{
																	color: '#200E32 !important'
																}}
																disabled={loading}
																className='mr-[0.9rem] custom-white-btn black-text smaller-padding'>
																Cancel
															</Button>

															<Button
																disabled={loading}
																className='custom-primary-two-btn smaller-padding'
																loading={loading}
																onClick={() => {
																	setCurrentStage(1)
																}}
															>
																Back
															</Button>
														</div>
												}
											</div>
									}

								</>
								:
								null
						}
					</div>
				</div>
			</Modal>
		</div>
	)
}

export default Addcurriculum